import { Box, SxProps } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "jalali-moment";

export default function AppDatePicker(props: {
    onChange: (date: string | null) => void;
    initialValue?: string;
    label?: string;
    sx?: SxProps;
}) {
    const onDateChange = (date: Date | null) => {
        if (!date) {
            props.onChange(null);
        } else {
            const utcOffset = moment().utcOffset();
            props.onChange(moment(date).add(utcOffset, "minutes").toJSON());
        }
    };

    return (
        <Box sx={{ ...props.sx, width: "100%" }}>
            <DatePicker
                sx={{ width: "100%" }}
                label={props.label}
                dayOfWeekFormatter={(d) => {
                    switch (d) {
                        case "ش":
                            return "ش";
                        case "1ش":
                            return "ی";
                        case "2ش":
                            return "د";
                        case "3ش":
                            return "س";
                        case "4ش":
                            return "چ";
                        case "5ش":
                            return "پ";
                        case "ج":
                            return "ج";
                    }
                    return "";
                }}
                onChange={onDateChange}
                value={
                    props.initialValue
                        ? moment(props.initialValue).toDate()
                        : null
                }
            />
        </Box>
    );
}
